import { render, staticRenderFns } from "./CommentInformation.vue?vue&type=template&id=14d21738&scoped=true&"
import script from "./CommentInformation.vue?vue&type=script&lang=js&"
export * from "./CommentInformation.vue?vue&type=script&lang=js&"
import style0 from "./CommentInformation.vue?vue&type=style&index=0&id=14d21738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d21738",
  null
  
)

export default component.exports